
import { useState, useEffect } from 'react';

export default function HomePage() {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const totalSlides = 4;

  const slides = [
    {
      title: "Premium Mango Pudding",
      subtitle: "Experience the perfect blend of fresh mango and creamy delight",
      backgroundImage:
        "https://public.readdy.ai/ai/img_res/30414f5592052f4ddbc09e4bc2b127f3.jpg",
      features: [
        {
          icon: "ri-heart-fill",
          title: "Premium Quality",
          description: "Made with finest mango pulp and natural ingredients",
        },
        {
          icon: "ri-leaf-fill",
          title: "Natural & Healthy",
          description: "No artificial preservatives, only 105 calories",
        },
        {
          icon: "ri-star-fill",
          title: "Award Winning",
          description: "Recognized for excellence in taste and quality",
        },
      ],
    },
    {
      title: "Mango Treasure Collection",
      subtitle: "Premium dessert collection crafted with love and care",
      backgroundImage:
        "https://readdy.ai/api/search-image?query=Happy%20African%20American%20family%20enjoying%20Mango%20Treasure%20pudding%20desserts%20together%2C%20parents%20and%20children%20laughing%20with%20thumbs%20up%20gestures%2C%20beautiful%20home%20dining%20room%2C%20warm%20family%20bonding%20moment%2C%20satisfied%20expressions%2C%20premium%20quality%20celebration&width=1200&height=600&seq=2&orientation=landscape",
      features: [],
    },
    {
      title: "Only 105 Calories",
      subtitle: "Guilt‑free indulgence without compromising on taste",
      backgroundImage:
        "https://readdy.ai/api/search-image?query=Happy%20Asian%20family%20with%20grandparents%20parents%20and%20children%20sharing%20Mango%20Treasure%20pudding%2C%20multi-generation%20family%20giving%20enthusiastic%20thumbs%20up%2C%20traditional%20Asian%20home%20setting%2C%20heartwarming%20family%20gathering%2C%20healthy%20eating%20lifestyle&width=1200&height=600&seq=3&orientation=landscape",
      features: [],
    },
    {
      title: "Natural Ingredients",
      subtitle: "Made with real mango pulp and fresh natural ingredients",
      backgroundImage:
        "https://readdy.ai/api/search-image?query=Happy%20Latino%20Hispanic%20family%20enjoying%20Mango%20Treasure%20pudding%20together%2C%20parents%20and%20children%20celebrating%20with%20thumbs%20up%20approval%2C%20vibrant%20colorful%20home%20atmosphere%2C%20festive%20family%20moment%2C%20satisfied%20customers%20showing%20joy&width=1200&height=600&seq=4&orientation=landscape",
      features: [],
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev >= totalSlides ? 1 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev >= totalSlides ? 1 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev <= 1 ? totalSlides : prev - 1));
  };

  const goToSlide = (slideNumber: number) => {
    if (slideNumber < 1 || slideNumber > totalSlides) return; // safety guard
    setCurrentSlide(slideNumber);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-amber-50 to-orange-50">
      {/* Free Shipping Banner */}
      <section className="bg-gradient-to-r from-rose-400 via-pink-400 to-orange-400 text-white py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center space-x-3">
            <i className="ri-truck-line text-2xl"></i>
            <span className="text-lg font-semibold">
              FREE SHIPPING on orders over $50!
            </span>
            <i className="ri-gift-line text-2xl"></i>
          </div>
        </div>
      </section>

      {/* Navigation */}
      <nav className="bg-gradient-to-r from-rose-100/95 via-pink-100/95 to-orange-100/95 backdrop-blur-md shadow-xl sticky top-0 z-50 border-b border-rose-200/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img
                src="https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/b38163c3c482e773cae655e9f9113361.png"
                alt="Mango Treasure Logo"
                className="h-14 w-auto mr-4 drop-shadow-sm"
              />
              <span
                className="text-3xl font-bold bg-gradient-to-r from-rose-600 via-pink-600 to-orange-600 bg-clip-text text-transparent"
                style={{ fontFamily: '"Pacifico", serif' }}
              >
                Mango Treasure
              </span>
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a
                  className="text-rose-700 hover:text-rose-900 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/"
                >
                  Home
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/products"
                >
                  Shop Products
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/story"
                >
                  Our Story
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/contact"
                >
                  Contact
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 px-4 py-3 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/orders"
                >
                  Track Orders
                </a>
                <a
                  className="bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-6 py-3 rounded-full hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg flex items-center space-x-2 font-semibold"
                  href="/cart"
                >
                  <i className="ri-shopping-cart-line text-lg"></i>
                  <span>Cart</span>
                </a>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={toggleMobileMenu}
                className="bg-white/90 backdrop-blur-sm hover:bg-white text-rose-600 p-3 rounded-lg shadow-lg transition-all duration-300 cursor-pointer border border-rose-100"
              >
                <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1 bg-white/95 backdrop-blur-md rounded-lg mt-2 shadow-xl border border-rose-200/50">
                <a
                  className="text-rose-700 hover:text-rose-900 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Home
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/products"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Shop Products
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/story"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Our Story
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/contact"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Contact
                </a>
                <a
                  className="text-gray-700 hover:text-rose-700 block px-3 py-2 text-base font-semibold transition-all duration-300 cursor-pointer rounded-lg hover:bg-rose-200/50"
                  href="/orders"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Track Orders
                </a>
                <a
                  className="bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-6 py-3 rounded-full hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transition-all duration-300 cursor-pointer shadow-lg flex items-center space-x-2 font-semibold justify-center mt-4"
                  href="/cart"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <i className="ri-shopping-cart-line text-lg"></i>
                  <span>Cart</span>
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Carousel */}
      <section className="relative h-[600px] overflow-hidden">
        <div className="relative w-full h-full">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                currentSlide === index + 1 ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div
                className="w-full h-full bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('${slide.backgroundImage}')`,
                }}
              >
                <div className="flex items-center justify-center h-full">
                  <div className="text-center px-4 max-w-4xl mx-auto">
                    <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
                      {slide.title}
                    </h1>
                    <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed drop-shadow-md">
                      {slide.subtitle}
                    </p>
                    <a
                      className="bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg transform hover:scale-105"
                      href="/products"
                    >
                      Shop Now
                    </a>

                    {slide.features.length > 0 && (
                      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
                        {slide.features.map((feature, featureIndex) => (
                          <div
                            key={featureIndex}
                            className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-rose-100/50"
                          >
                            <div className="w-12 h-12 bg-gradient-to-r from-rose-400 via-pink-400 to-orange-400 rounded-full flex items-center justify-center mx-auto mb-4">
                              <i className={`${feature.icon} text-white text-xl`}></i>
                            </div>
                            <h3 className="font-semibold text-rose-800 mb-2">
                              {feature.title}
                            </h3>
                            <p className="text-rose-600 text-sm">
                              {feature.description}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/90 backdrop-blur-sm hover:bg-white text-rose-600 p-3 rounded-full shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer border border-rose-100"
        >
          <i className="ri-arrow-left-line text-xl"></i>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/90 backdrop-blur-sm hover:bg-white text-rose-600 p-3 rounded-full shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer border border-rose-100"
        >
          <i className="ri-arrow-right-line text-xl"></i>
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-3">
          {[1, 2, 3, 4].map((slideNum) => (
            <button
              key={slideNum}
              onClick={() => goToSlide(slideNum)}
              className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                currentSlide === slideNum
                  ? 'bg-rose-500 scale-125'
                  : 'bg-white/60 hover:bg-white/80'
              }`}
            />
          ))}
        </div>

        {/* Slide Counter */}
        <div className="absolute bottom-6 right-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full text-rose-600 font-medium border border-rose-100">
          {currentSlide} / {totalSlides}
        </div>
      </section>

      {/* Product Introduction */}
      <section className="py-20 bg-gradient-to-r from-rose-50 via-pink-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <img
                  src="https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/b38163c3c482e773cae655e9f9113361.png"
                  alt="Mango Treasure Logo"
                  className="h-24 w-auto mr-6 drop-shadow-lg"
                />
                <h2 className="text-4xl font-bold bg-gradient-to-r from-rose-700 via-pink-700 to-orange-700 bg-clip-text text-transparent">
                  Introducing Mango Treasure Pudding
                </h2>
              </div>
              <p className="text-lg text-rose-700 mb-6 leading-relaxed">
                Mango Treasure proudly launches a new premium mango pudding product that
                represents the perfect combination of fresh, top-quality mango pulp and
                fresh ingredients that will captivate your taste buds.
              </p>
              <p className="text-lg text-rose-700 mb-8 leading-relaxed">
                Our Mango Pudding is a sweet and soft premium dessert that sets a new
                standard for mango pudding with the deep flavor and freshness of mango.
              </p>
              <a
                className="inline-block bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transform hover:scale-105 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
                href="/story"
              >
                Learn Our Story
              </a>
            </div>
            <div className="relative">
              <div className="bg-gradient-to-br from-rose-200/80 via-pink-200/80 to-orange-200/80 rounded-3xl p-8 shadow-2xl border border-rose-100">
                <img
                  alt="Mango Treasure Premium Logo"
                  className="w-full h-80 object-contain rounded-2xl shadow-lg"
                  src="https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/5d21aecc675be4138872c9ece8fe8699.png"
                />
              </div>
              <div className="absolute -top-4 -right-4 bg-gradient-to-r from-amber-400 via-orange-400 to-red-400 text-white px-6 py-3 rounded-full font-bold shadow-lg">
                Premium Brand
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold bg-gradient-to-r from-rose-700 via-pink-700 to-orange-700 bg-clip-text text-transparent mb-4">
              Why Choose Mango Treasure?
            </h2>
            <p className="text-xl text-rose-600 max-w-3xl mx-auto">
              Experience the difference with our premium mango pudding crafted with
              care and quality
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-rose-400 via-pink-400 to-orange-400 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-30 shadow-lg">
                <i className="ri-leaf-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-rose-800 mb-3">
                Natural Ingredients
              </h3>
              <p className="text-rose-600">
                Made with real mango pulp and fresh natural ingredients, no artificial
                additives
              </p>
            </div>
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-rose-400 via-pink-400 to-orange-400 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-30 shadow-lg">
                <i className="ri-heart-pulse-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-rose-800 mb-3">
                Low Calorie
              </h3>
              <p className="text-rose-600">
                Only 105 calories per serving, perfect for health-conscious dessert
                lovers
              </p>
            </div>
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-rose-400 via-pink-400 to-orange-400 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-30 shadow-lg">
                <i className="ri-award-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-rose-800 mb-3">
                Premium Quality
              </h3>
              <p className="text-rose-600">
                Award-winning taste and texture that sets new standards in dessert
                excellence
              </p>
            </div>
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-rose-400 via-pink-400 to-orange-400 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-30 shadow-lg">
                <i className="ri-time-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-rose-800 mb-3">
                Fresh Daily
              </h3>
              <p className="text-rose-600">
                Made fresh daily to ensure optimal taste and quality in every cup
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-rose-600 via-pink-600 to-orange-600">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Experience Premium Taste?
          </h2>
          <p className="text-xl text-rose-100 mb-8 max-w-2xl mx-auto">
            Join thousands of satisfied customers who have made Mango Treasure Pudding
            their favorite dessert choice
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              className="bg-gradient-to-r from-rose-500 via-pink-500 to-orange-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-rose-600 hover:via-pink-600 hover:to-orange-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg transform hover:scale-105"
              href="/products"
            >
              Shop Now
            </a>
            <a
              className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-rose-600 transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              href="/contact"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-rose-900 via-pink-900 to-orange-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <img
                  src="https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/b38163c3c482e773cae655e9f9113361.png"
                  alt="Mango Treasure Logo"
                  className="h-10 w-auto mr-3 drop-shadow-sm"
                />
                <h3
                  className="text-2xl font-bold"
                  style={{ fontFamily: '"Pacifico", serif' }}
                >
                  Mango Treasure
                </h3>
              </div>
              <p className="text-rose-200 mb-4">
                Premium mango pudding crafted with love and natural ingredients for
                the perfect dessert experience.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <a
                    className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                    href="/"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                    href="/products"
                  >
                    Products
                  </a>
                </li>
                <li>
                  <a
                    className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                    href="/story"
                  >
                    Our Story
                  </a>
                </li>
                <li>
                  <a
                    className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                    href="/contact"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Customer Service</h4>
              <ul className="space-y-2">
                <li>
                  <a
                    className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                    href="/orders"
                  >
                    Track Orders
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                  >
                    FAQ
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                  >
                    Shipping Info
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                  >
                    Returns
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Connect With Us</h4>
              <div className="flex space-x-4 mb-4">
                <a
                  href="#"
                  className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-2xl"></i>
                </a>
                <a
                  href="#"
                  className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-fill text-2xl"></i>
                </a>
                <a
                  href="#"
                  className="text-rose-200 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-fill text-2xl"></i>
                </a>
              </div>
              <p className="text-rose-200 text-sm">
                Follow us for updates and special offers
              </p>
            </div>
          </div>
          <div className="border-t border-rose-800 mt-8 pt-8 text-center">
            <p className="text-rose-200">
              © 2024 Mango Treasure. All rights reserved. |
              <a
                href="https://readdy.ai/?origin=logo"
                className="text-rose-200 hover:text-white ml-2 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
